import React, { memo } from 'react'
import { useQuery } from '@tanstack/react-query'
import mime from 'mime'
import { oembed } from '@loomhq/loom-embed'
import { FilePreviewProps } from './types'
import { FileIcon } from './FileIcon'
import RenderFile from './RenderFile'
import { ReactComponent as Loom } from './loom.svg'
import styles from './_.module.css'

export const FilePreviewV2 = memo(
  ({ id, name, url }: FilePreviewProps): JSX.Element => {
    const mimeType = mime.getType(name ?? '')
    const { data: loomData } = useQuery(
      ['loom', url],
      () => {
        if (!url) return
        return oembed(url)
      },
      {
        enabled: url !== null
      }
    )

    return (
      <div className={styles.file}>
        <RenderFile
          mimeType={mimeType}
          id={id}
          name={name ?? loomData?.title}
          url={url}
        />
        <div className={styles.content}>
          {url ? <Loom /> : <FileIcon mimeType={mimeType} />}
          <span title={name ?? loomData?.title} className={styles.name}>
            {name ?? loomData?.title}
          </span>
        </div>
      </div>
    )
  }
)
